import { FaIdCard } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Search from "../../Search/Search";
import Title from "../../Title/Title";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import { Tooltip } from "react-tooltip";
import Add from "../../Buttons/Add";
import { useDelete, useFetch } from "../../../ApiS";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Loader from "../../Loader";
import ButtonRed from "../../Buttons/Buttonred";
import { useState } from "react";
import Table from "../../Table";

interface Employee {
  id: string | number;
  first_name?: string;
  last_name?: string;
  father_name?: string;
  mother_name?: string;
  birth_place?: string;
  birth_date?: string;
  id_front_side_image?: string;
  id_back_side_image?: string;
  admin_decision_date?: string;
  admin_decision_number?: string;
  password?: string;
  national_id?: string;
  place_of_registration?: string;
}

interface EmployeeData {
  data: Employee;
}

const Information_Emp: React.FC = () => {
  const { id } = useParams();
  const { data } = useFetch(
    `admin/employees/${id}`,
    `employees${id}`
  );
  console.log(data);

  return (
    <>
      <Row>
        <Col>
          <Title title=" الموظفين" />
        </Col>
      </Row>

      <Row>
        <Col lg={10} md={4} className="mx-auto overflow-x-scroll">
          {/* <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
              <tr>
                <td> اسم الموظف ونسبته</td>
                <td> الاب </td>
                <td> الام </td>
                <td> الايميل </td>
                <td> رقمه</td>
                <td>العمليات</td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              
                <tr key={id} className="border-2 border-white">
                  <td>{data?.data?.admin_decision_date

                  }</td>
              
                </tr>
             
            </tbody>
          </table> */}
          <div className="w-full bg-slate-100  max-lg:w-[850px]  my-5  rounded-2xl ">
            <Row className="w-[95%] flex justify-center text-base text-black font-bold">
              <Col className="flex justify-between items-center p-4 mx-auto">
                <p>الاسم الكامل</p>
                <p>رقم الموظف</p>
                <p>اسم الأب</p>
                <p>اسم الأم</p>
                <p>تاريخ الميلاد</p>
                <p>مكان الميلاد</p>
                <p> الصورة الأمامية</p>
                <p> الصورة الخلفية</p>
                <p>الرقم الوطني</p>
                <p> مكان التسجيل</p>
              </Col>
            </Row>
            <Col className="flex justify-between items-center p-4 mx-auto">
              <p className="">{data?.data?.first_name}</p>
              <p>رقم الموظف</p>
              <p>اسم الأب</p>
              <p>اسم الأم</p>
              <p>تاريخ الميلاد</p>
              <p>مكان الميلاد</p>
              <p> الصورة الأمامية</p>
              <p> الصورة الخلفية</p>
              <p>الرقم الوطني</p>
              <p> مكان التسجيل</p>
            </Col>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Information_Emp;
